import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusValueRows } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-mist border-y border-mist-dark" data-id="element-16" data-mp="22ebqysm0mq8w">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="1ydrxbz0ni4ri">
        <div className="text-center mb-16" data-id="element-18" data-mp="1yet7m19uen86">
          <p className="text-azure font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1anxlnks2im8u">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-20" data-mp="15qnn9fmpb08v">
            🎁 The <span className="text-gold-solid" data-id="element-21" data-mp="1jhsscx8u8kql">5 Professional</span> Bonus Guides
          </h2>
          <p className="text-lg text-slate mt-4 max-w-3xl mx-auto" data-id="element-22" data-mp="1epsjugepcjie">
            Five additional coaching resources designed to give you more variety, stronger
            planning and better competition preparation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-23" data-mp="mws6z8xv6004">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-mist-dark rounded-2xl p-8 relative shadow-sm flex flex-col ${index === bonuses.length - 1 && bonuses.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-24" data-mp="29q0cuvn85y6z" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-25" data-mp="1vsk3bb9mtob0">
                🎁 BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold/15 rounded-full flex items-center justify-center text-gold-dark mb-4" data-id="element-26" data-mp="25s2n9rpjla32">
                <Gift size={24} data-id="element-27" data-mp="3c8o8b7i44j04" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-24 text-navy" data-id="element-28" data-mp="3h4lmp89tffa9">
                {bonus.title}
              </h3>
              <p className="text-sm text-azure-dark font-medium mb-4 leading-snug" data-id="element-29" data-mp="1h1kfk5dmx6yx">
                {bonus.headline}
              </p>
              <div className="self-start bg-mist px-3 py-1 rounded mb-4 border border-mist-dark" data-id="element-30" data-mp="1q43iephf7jl6">
                <span className="text-slate text-sm" data-id="element-31" data-mp="1m2i4r1x2b19x">
                  Value: <span className="line-through text-alert" data-id="element-32" data-mp="1m39qzm4rrmnj">${bonus.value}</span>
                </span>
                <span className="text-gold-dark font-bold ml-2" data-id="element-33" data-mp="yd5nrfvhtox2">→ FREE</span>
              </div>
              <ul className="space-y-3 mb-6 flex-grow" data-id="element-34" data-mp="tfnpqkj0ku3u">
                {bonus.points.map(point => <li key={point} className="text-slate text-sm leading-relaxed" data-id="element-35" data-mp="177c0ajdm7aip">
                    {point}
                  </li>)}
              </ul>
              <p className="text-navy text-sm italic font-medium mt-auto" data-id="element-36" data-mp="enlu5cnz8n9m">{bonus.benefit}</p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-gold/40 rounded-2xl p-8 max-w-2xl mx-auto shadow-sm" data-id="element-37" data-mp="alidm9mgashh">
          <h3 className="text-2xl font-serif font-bold text-navy text-center mb-6" data-id="element-38" data-mp="3rp65grolgwd0">
            💰 Total Value of the 5 Bonuses
          </h3>
          <div className="overflow-hidden rounded-xl border border-mist-dark" data-id="element-39" data-mp="janr68828kky">
            <table className="w-full text-left" data-id="element-40" data-mp="o7nysnkk5ve6">
              <thead className="bg-navy text-white text-xs uppercase tracking-wider" data-id="element-41" data-mp="9bq7pjphrh8t">
                <tr data-id="element-42" data-mp="9e2ldko7v5g2">
                  <th scope="col" className="px-4 py-3 font-bold" data-id="element-43" data-mp="eajaoi75jpuq">
                    Bonus
                  </th>
                  <th scope="col" className="px-4 py-3 font-bold text-right" data-id="element-44" data-mp="2u1nxhj2rbya2">
                    Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-45" data-mp="3f86fn3lfllih">
                {bonusValueRows.map(row => <tr key={row.label} className="border-t border-mist-dark" data-id="element-46" data-mp="3f9hin171yp8j">
                    <td className="px-4 py-3 text-sm text-slate" data-id="element-47" data-mp="3agof2gnblmy1">{row.label}</td>
                    <td className="px-4 py-3 text-sm text-navy font-medium text-right" data-id="element-48" data-mp="35hk7tvjyhzac">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="border-t border-mist-dark bg-mist" data-id="element-49" data-mp="226e0yvsr7nx">
                  <td className="px-4 py-3 text-sm font-bold text-navy" data-id="element-50" data-mp="1zafb8c4keyf">Total Bonus Value</td>
                  <td className="px-4 py-3 text-sm font-bold text-alert text-right line-through" data-id="element-51" data-mp="3t5uyk5vxuikw">
                    $63
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-center mt-6" data-id="element-52" data-mp="2ctocova1cffo">
            <p className="text-lg text-navy mb-2" data-id="element-53" data-mp="2cuh8x2bdbmjk">Your Price Today</p>
            <p className="text-4xl font-bold text-gold-solid mb-4" data-id="element-54" data-mp="27u3bsfbb1x0b">🎁 ALL 5 BONUSES FREE</p>
            <p className="text-sm text-slate" data-id="element-55" data-mp="ncu3aq2wyrft">
              Included with Wrestling Coach Ready at no additional cost.
            </p>
          </div>
        </motion.div>

        <CountdownTimer data-id="element-56" data-mp="s9au5s1hzjwl" />
      </div>
    </section>;
}